import { LeaveRequest } from "../../types/LeaveRequest";
import {
  LeaveRequestAction,
  LeaveRequestActionType,
} from "../actions/leaveRequestAction";

const initialState: LeaveRequest[] = [];

export const leaveRequestReducer = (
  state = initialState,
  action: LeaveRequestAction,
): LeaveRequest[] => {
  switch (action.type) {
    case LeaveRequestActionType.FETCH_LEAVE_REQUESTS:
      return action.data;
    case LeaveRequestActionType.ADD_LEAVE_REQUEST:
      return [...state, action.data];
    case LeaveRequestActionType.EDIT_LEAVE_REQUEST:
      // return state.map(lr =>
      //   lr.id === action.data.id
      //     ? { ...lr, status: action.data.status, approvedBy: action.data.approvedBy }
      //     : lr
      // );
      const updated = [...state];
      const index = updated.findIndex((att) => att.id === action.data.id);
      if (index > -1) {
        updated[index] = { ...action.data };
      }
      return updated;
    case LeaveRequestActionType.EDIT_LEAVE_STATUS:
      return state.map((lr) =>
        lr.id === action.data.id
          ? {
              ...lr,
              status: action.data.status,
              approvedBy: action.data.approvedBy,
            }
          : lr,
      );
    case LeaveRequestActionType.DELETE_LEAVE_REQUEST:
      return state.filter((lr) => lr.id !== action.data);
    default:
      return state;
  }
};
